import { FormDataGroup } from 'src/types';

export const leadsTestDrivePartialData = (
	isConfigure?: boolean,
	isDealer?: boolean,
): Partial<FormDataGroup> => ({
	headers: { FORM_OBJECTIVE: 'Más Información' },
	fields: {
		formFields: {},
		formularioFlag: 'masInformacion',
		formName: isConfigure
			? 'lead-test_drive-configure'
			: isDealer
			? 'lead-test_drive-dealer'
			: 'lead-test_drive',
		formType: 'contact',
		pageCategory: 'Más Información',
	},
});
